export interface DocumentWithFullscreen extends Document {
    mozFullScreenElement?: Element;
    msFullscreenElement?: Element;
    webkitFullscreenElement?: Element;
    msExitFullscreen?: () => void;
    mozCancelFullScreen?: () => void;
    webkitExitFullscreen?: () => void;
}

export interface DocumentElementWithFullscreen extends HTMLElement {
    msRequestFullscreen?: () => void;
    mozRequestFullScreen?: () => void;
    webkitRequestFullscreen?: () => void;
}


export function toggleFullscreen(document: DocumentWithFullscreen, target: DocumentElementWithFullscreen) {
    if (isFullScreen(document)) {
        closeFullscreen(document);
    } else {
        openFullscreen(target);
    }
}

export function isFullScreen(document: DocumentWithFullscreen): boolean {
    return !!(document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement);
}

function openFullscreen(target: DocumentElementWithFullscreen) {
    if (target.requestFullscreen) {
        target.requestFullscreen();
    } else if (target.mozRequestFullScreen) {
        /* Firefox */
        target.mozRequestFullScreen();
    } else if (target.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        target.webkitRequestFullscreen();
    } else if (target.msRequestFullscreen) {
        /* IE/Edge */
        target.msRequestFullscreen();
    }
}

function closeFullscreen(document: DocumentWithFullscreen) {
    if (document.exitFullscreen) {
        document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
        /* Firefox */
        document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
        /* IE/Edge */
        document.msExitFullscreen();
    }
}
